import React, { useState, useEffect } from 'react';
import { Button, TextField, FormControl, Grid, MenuItem, Select, InputLabel, Autocomplete, Typography, Table, TableBody, TableCell, TableRow, TableHead, Paper, InputAdornment } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useSucursal } from '../contexts/SucursalContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionPromocionesDAnalisis({ promotion, onCancel, onSave, isEditMode = false }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descuento, setDescuento] = useState({
        fechaInicio: '',
        fechaFin: '',
        descripcion: '',
        edadDesde: '',
        edadHasta: '',
        sexo: null,
        analisis: null,
        porcentaje: 0,
        urlImagen: '',
        porcentaje_remitido: 0
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [listaDescuentos, setListaDescuentos] = useState([]);
    const [analisisDisponibles, setAnalisisDisponibles] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    const [perfil, setPerfil] = useState(null);
    const [sexos, setSexos] = useState([]);
    const { user } = useUser();
    const [deletedItems, setDeletedItems] = useState([]);
    const { sucursalSeleccionada } = useSucursal();
    const { tienePermiso } = useAccesos();

    const [descripcionImgPagWeb, setDescripcionImgPagWeb] = useState('');
    const [palabrasImgClavePagWeb, setPalabrasImgClavePagWeb] = useState('');

    useEffect(() => {
        // Cargar sexos y análisis al montar el componente
        fetchSexos();
        fetchPerfiles();
        fetchAnalisis();
    }, []);

    useEffect(() => {
        if (promotion) {
            console.log('Promotion:', promotion);
            setDescuento({
                fechaInicio: promotion.fechaDesde ? promotion.fechaDesde.split('T')[0] : '',
                fechaFin: promotion.fechaHasta ? promotion.fechaHasta.split('T')[0] : '',
                descripcion: promotion.descripcion || '',
                edadDesde: promotion.edadDesde != null ? promotion.edadDesde : '',
                edadHasta: promotion.edadHasta != null ? promotion.edadHasta : '',
                sexo: promotion.idSexo || null,
                urlImagen: promotion.urlImagen || '',
                analisis: null,
                porcentaje: 0,
                porcentaje_remitido: 0,
            });
            setDescripcionImgPagWeb(promotion.descripcionImgPagWeb || '');
            setPalabrasImgClavePagWeb(promotion.palabrasImgClavePagWeb || '');
            console.log('Promotion:', promotion);
            // Set image preview if urlImagen exists
            if (promotion.urlImagen) {
                if (typeof promotion.urlImagen === 'string') {
                    setImagePreview(promotion.urlImagen);
                } else if (promotion.urlImagen instanceof Blob || promotion.urlImagen instanceof File) {
                    setImagePreview(URL.createObjectURL(promotion.urlImagen));
                }
            }
        }
    }, [promotion]);

    useEffect(() => {
        if (promotion && analisisDisponibles.length > 0) {
            fetchPromotionDetails();
        }
    }, [promotion, analisisDisponibles]);

    const fetchPerfiles = async () => {
        try {
            const response = await fetch(`${server}/MgAnalisisGeneralPerfiles`);
            const data = await response.json();
            setPerfiles(data.$values || []);
        } catch (error) {
            console.error('Error al cargar los perfiles:', error);
        }
    };

    const fetchPromotionDetails = async () => {
        try {
            // Obtener los detalles de la promoción
            const response = await fetch(`${server}/PrPromocionesDetallesDeDescuentoes/byidpromocion/${promotion.id}`);
            const data = await response.json();
            const detalles = data.$values || [];

            // Mapear los detalles al formato de listaDescuentos
            const detallesFormateados = detalles.map(detalle => {
                const analisisEncontrado = analisisDisponibles.find(a => a.idTipoAnalisis === detalle.idTipoAnalisis);
                return {
                    id: detalle.id, // Incluir el id del detalle
                    analisis: analisisEncontrado || null,
                    porcentaje: detalle.porcentaje,
                    porcentaje_remitido: detalle.descuentoRemitido
                };
            });

            setListaDescuentos(detallesFormateados);
        } catch (error) {
            console.error('Error al cargar los detalles de la promoción:', error);
        }
    };




    const fetchAnalisis = async () => {
        try {
            const response = await fetch(`${server}/MgAnalisisGeneralTiposDeAnalisis`);
            const data = await response.json();
            setAnalisisDisponibles(data.$values || []);
        } catch (error) {
            console.error('Error al cargar los análisis:', error);
        }
    };

    const fetchSexos = async () => {
        try {
            const response = await fetch(`${server}/MgSexoes`);
            const data = await response.json();
            setSexos(data.$values || []);
        } catch (error) {
            console.error('Error al cargar los sexos:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'porcentaje_remitido') {
            let porcentaje = parseFloat(value);

            if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Porcentaje inválido',
                    text: 'El porcentaje debe ser un número entre 0 y 100.'
                });
                return;
            }

            setDescuento(prev => ({ ...prev, [name]: value }));
        } else {
            setDescuento(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleChangeRemitido = (e) => {
        const { name, value } = e.target;

        if (name === 'porcentaje_remitido') {
            let porcentaje = parseFloat(value);

            if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
                alert('El porcentaje debe estar entre 0 y 100.');
                return;
            }

            setDescuento(prev => ({ ...prev, [name]: value }));
        } else {
            setDescuento(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAgregar = () => {
        if (!descuento.analisis) {
            Swal.fire({
                icon: 'info',
                title: 'Selecciona un análisis',
                text: 'Por favor, selecciona un análisis antes de agregar.'
            });
            return;
        }

        // Verificar si el análisis ya está en la lista de descuentos
        const existeAnalisis = listaDescuentos.some(item => item.analisis.idTipoAnalisis === descuento.analisis.idTipoAnalisis);

        if (existeAnalisis) {
            alert("Este análisis ya ha sido agregado a la lista de descuentos.");
            return;
        }

        // Verificar porcentaje válido
        const porcentaje = parseFloat(descuento.porcentaje);
        if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
            alert("El porcentaje debe ser un número entre 0 y 100.");
            return;
        }

        // Si no existe, proceder a agregarlo
        const nuevoDescuento = {
            id: 0, // Indica que es un detalle nuevo
            analisis: descuento.analisis,
            porcentaje: porcentaje,
            porcentaje_remitido: descuento.porcentaje_remitido
        };

        setListaDescuentos(prev => [...prev, nuevoDescuento]);

        // Reiniciar los campos de análisis y porcentaje
        setDescuento(prev => ({ ...prev, analisis: null, porcentaje: 0, porcentaje_remitido: 0 }));
    };


    const handleEliminar = (index) => {
        setListaDescuentos(prev => {
            const itemToDelete = prev[index];
            // Si el detalle tiene id mayor a cero, agregarlo al arreglo de eliminados
            if (itemToDelete.id && itemToDelete.id > 0) {
                setDeletedItems(prevDeleted => [...prevDeleted, itemToDelete]);
            }
            // Remover el detalle de la lista de descuentos
            return prev.filter((_, i) => i !== index);
        });
    };


    // Función para comprimir la imagen
    const comprimirImagen = async (imagen) => {
        const opciones = {
        maxSizeMB: 0.5,           // Tamaño máximo en MB (ej: 0.5 MB = 500 KB)
        maxWidthOrHeight: 1280,   // Redimensiona si es más grande
        useWebWorker: true,
        initialQuality: 0.8
        };
    
        try {
            const imagenComprimida = await imageCompression(imagen, opciones);
        
        //extensión original
        const extension = imagen.name.split('.').pop();
        const nuevoNombre = `${imagen.name.split('.')[0]}.${extension}`;
    
        //Crear un nuevo objeto File con nombre y extension correcta
        const archivoFinal = new File (
          [imagenComprimida],
          nuevoNombre,
          {
            type: imagen.type,
            lastModified: Date.now()
          }
        );
            return archivoFinal;
        } catch (error) {
            console.error('Error al comprimir imagen:', error);
            return imagen; // Si falla, usa la imagen original
        }
        };
    



    const handleImageUpload = async (file) => {
        const archivoComprimido = await comprimirImagen(file);

        const username = '' + user.codigoUsuario + '';
        const formData = new FormData();
        formData.append('file', archivoComprimido);

        try {
            // Use different URL parameter for new vs existing promotions
            const promoIdParam = promotion ? `promoId=${promotion.id}` : 'promoId=0';
            const response = await fetch(`${server}/PrPromociones/upload?usuario=${username}&${promoIdParam}`, {
                method: 'POST',
                body: formData
            });

            console.log(response);
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setDescuento(prev => ({ ...prev, urlImagen: data.urlFoto }));
                if (data.urlFoto) {
                    if (typeof data.urlFoto === 'string') {
                        setImagePreview(data.urlFoto);
                    } else if (data.urlFoto instanceof Blob || data.urlFoto instanceof File) {
                        setImagePreview(URL.createObjectURL(data.urlFoto));
                    }
                }
            } else {
                alert('Error al subir la imagen');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error al subir la imagen');
        }
    };
    const handleGuardarPromocion = async () => {
        try {
            // Validar campos requeridos
            if (!descuento.fechaInicio || !descuento.fechaFin || !descuento.descripcion) {
                alert('Por favor, completa los campos de fecha y descripción.');
                return;
            }
            if (listaDescuentos.length === 0) {
                alert('Por favor, agrega al menos un descuento.');
                return;
            }


            let codigoPromocion = promotion ? promotion.codigo : '';

            if (!promotion) {
                // Paso 1: Llamar a la API para obtener promociones existentes con la misma fechaInicio
                const responsePromociones = await fetch(`${server}/PrPromociones/promociones`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        search: '',
                        desde: descuento.fechaInicio,
                        hasta: descuento.fechaFin
                    })
                });

                const dataPromociones = await responsePromociones.json();
                const promocionesExistentes = dataPromociones.$values || [];

                // Paso 2: Filtrar promociones donde fechaInicio es igual a descuento.fechaInicio
                const promocionesMismaFechaInicio = promocionesExistentes.filter(promo => {
                    // Obtener la parte de la fecha sin la hora
                    const fechaInicioPromo = promo.fechaDesde ? promo.fechaDesde.split('T')[0] : '';
                    return fechaInicioPromo === descuento.fechaInicio;
                });

                // Paso 3: Calcular el correlativo
                const correlativoNumero = promocionesMismaFechaInicio.length + 1;
                const correlativo = correlativoNumero.toString().padStart(3, '0'); // Asegurar 3 dígitos

                // Paso 4: Generar el código con formato [AÑO][MES][CORRELATIVO]
                const [yy, mm, dd] = descuento.fechaInicio.split('-').map(n => parseInt(n, 10));
                const fechaInicioDate = new Date(yy, mm - 1, dd);  // año, mesIndex, día
                console.log('fechaInicioDate', fechaInicioDate);
                // Mon Jun 01 2025 00:00:00 GMT-0600

                const año = yy.toString();
                const mes = mm.toString().padStart(2, '0');
                codigoPromocion = `${año}${mes}${correlativo}`;
                // const fechaInicioDate = new Date(descuento.fechaInicio);
                // const año = fechaInicioDate.getFullYear().toString();
                // const mes = (fechaInicioDate.getMonth() + 1).toString().padStart(2, '0'); // Meses de 1 a 12
                // codigoPromocion = `${año}${mes}${correlativo}`;
            }



            // Paso 5: Construir los datos para el encabezado, incluyendo el código
            const encabezadoData = {
                id: promotion ? promotion.id : undefined, // Incluimos el ID si estamos modificando
                codigo: codigoPromocion, // Usamos el código existente si estamos modificando
                fechaDesde: descuento.fechaInicio,
                fechaHasta: descuento.fechaFin,
                descripcion: descuento.descripcion,
                edadDesde: descuento.edadDesde !== '' ? parseInt(descuento.edadDesde) : null,
                edadHasta: descuento.edadHasta !== '' ? parseInt(descuento.edadHasta) : null,
                idSexo: descuento.sexo,
                urlImagen: descuento.urlImagen,
                idTipo: 1,
                ...(promotion
                    ? {
                        modificadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                        ingresadoPor: promotion.ingresadoPor,
                        fechaIngreso: promotion.fechaIngreso,
                    }
                    : { ingresadoPor: user ? user.codigoUsuario : 'ADMIN               ' }
                ),
                descripcionImgPagWeb,
                palabrasImgClavePagWeb,
            };
            console.log('encabezadoData', encabezadoData);
            const method = promotion ? 'PUT' : 'POST';
            const url = promotion ? `${server}/PrPromociones/${promotion.id}` : `${server}/PrPromociones`;

            // Hacer la solicitud POST o PUT para guardar el encabezado
            const responseEncabezado = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(encabezadoData)
            });
            console.log(encabezadoData);
            if (responseEncabezado.ok) {
                // Obtener el ID de la promoción creada
                let promocionId;
                // console.log('responseEncabezado', responseEncabezado.json());
                if (!promotion) {
                    const promocionGuardada = await responseEncabezado.json();
                    promocionId = promocionGuardada.id ? promocionGuardada.id : promotion.id;
                } else {

                    promocionId = promotion.id;
                }


                const username = '' + user.codigoUsuario + '/';
                // Procesar detalles eliminados
                for (const item of deletedItems) {
                    try {
                        const response = await fetch(`${server}/PrPromocionesDetallesDeDescuentoes/${item.id}/${username}`, {
                            method: 'DELETE',
                        });
                        if (!response.ok) {
                            const errorData = await response.json();
                            console.error('Error al eliminar detalle:', errorData);
                        }
                    } catch (error) {
                        console.error('Error al eliminar detalle:', error);
                    }
                }


                // Procesar detalles nuevos (id == 0 o indefinido)
                for (const item of listaDescuentos) {
                    if (!item.id || item.id === 0) {
                        // Detalle nuevo, realizar solicitud POST
                        const detalleData = {
                            idPromocion: promocionId,
                            idTipoAnalisis: item.analisis.idTipoAnalisis,
                            porcentaje: item.porcentaje,
                            descuentoRemitido: item.porcentaje_remitido,
                            ingresadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                        };

                        const responseDetalle = await fetch(`${server}/PrPromocionesDetallesDeDescuentoes`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(detalleData)
                        });

                        if (!responseDetalle.ok) {
                            const errorData = await responseDetalle.json();
                            alert('Error al guardar un detalle: ' + errorData.message);
                            return;
                        }
                    }
                }

                // Si todo salió bien
                Swal.fire({
                    icon: 'success',
                    title: '¡Listo!',
                    text: 'Descuentos guardados exitosamente.',
                });
                
                // Llamar a onSave para cerrar el modal y refrescar datos
                if (onSave) {
                    onSave();
                }
                
                // Reiniciar el formulario solo si no estamos en modo edición
                if (!isEditMode) {
                    setDescuento({
                        fechaInicio: '',
                        fechaFin: '',
                        descripcion: '',
                        edadDesde: '',
                        edadHasta: '',
                        sexo: null,
                        analisis: null,
                        porcentaje: 0,
                        urlImagen: '',
                        porcentaje_remitido: 0
                    });
                    setListaDescuentos([]);
                    setImagePreview(null);
                    setDescripcionImgPagWeb('');
                    setPalabrasImgClavePagWeb('');
                }


            } else {
                // Manejar errores al guardar el encabezado
                const errorData = await responseEncabezado.json();
                alert('Error al guardar la promoción: ' + errorData.message);
            }
        } catch (error) {
            console.error('Error al guardar la promoción y los descuentos:', error);
            alert('Hubo un error al guardar la promoción y los descuentos.');
        }
    };

    // Reemplaza tus dos handlers actuales por éste:
    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        // Permitir borrar todo (para que pueda limpiar el campo)
        if (value === '') {
            setDescuento(prev => ({ ...prev, [name]: '' }));
            return;
        }
        // Intentar parsear
        const numero = parseFloat(value);
        if (isNaN(numero) || numero < 0 || numero > 100) {
            Swal.fire({
                icon: 'warning',
                title: 'Porcentaje inválido',
                text: 'El porcentaje debe ser un número entre 0 y 100.'
            });
            return;
        }
        // Guardar el número ya validado
        setDescuento(prev => ({ ...prev, [name]: numero }));
    };

    const handleAgregarAnalisisPerfil = async () => {
        if (!descuento.perfil) {
            Swal.fire({
                text: "Por favor, selecciona un perfil.",
                icon: "warning"
            });
            return;
        }

        try {
            const response = await fetch(`${server}/MgAnalisisGeneralPerfilesAnalisis/AnalisisbyPerfilbySucursal/${descuento.perfil.idPerfil}/${sucursalSeleccionada.idSucursal}`);
            const data = await response.json();

            if (data && data.$values && Array.isArray(data.$values)) {
                const nuevosAnalisis = data.$values.filter((analisisItem) => {
                    return !listaDescuentos.some(item => item.analisis.idTipoAnalisis === analisisItem.idTipoAnalisis);
                });

                if (nuevosAnalisis.length === 0) {
                    Swal.fire({
                        icon: "info",
                        title: "Sin nuevos análisis",
                        text: "Todos los análisis de este perfil ya han sido agregados."
                    });
                    return;
                }

                const descuentoGlobal = descuento.porcentaje || 0;

                const nuevoDescuento = nuevosAnalisis.map((analisisItem) => ({
                    id: 0,
                    analisis: analisisItem,
                    porcentaje: descuentoGlobal,
                    porcentaje_remitido: descuento.porcentaje_remitido || 0
                }));

                setListaDescuentos(prev => [...prev, ...nuevoDescuento]);

                // Limpiar perfil seleccionado
                setDescuento(prev => ({ ...prev, perfil: null, porcentaje: 0, porcentaje_remitido: 0 }));
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "Perfil sin análisis",
                    text: "No se encontraron análisis para el perfil seleccionado."
                });
            }
        } catch (error) {
            console.error('Error al cargar los análisis del perfil:', error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al cargar los análisis del perfil."
            });
        }
    };



    return (
        <>
            <div className="right_col" role="main">
                <div className="x_content">
                    <br />
                    {/* <div className="row"> */}
                    {/* <div className="col-md-7 col-sm-12 offset-md-3"> */}
                    <Paper style={{ padding: 10, margin: "auto", maxWidth: '100%' }}>
                        <Typography variant="h6" gutterBottom>
                            Configuración de Promociones por Analisis
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    label="Fecha desde"
                                    type="date"
                                    name="fechaInicio"
                                    fullWidth
                                    value={descuento.fechaInicio}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Fecha hasta"
                                    type="date"
                                    name="fechaFin"
                                    fullWidth
                                    value={descuento.fechaFin}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Descripción de la promoción"
                                    fullWidth
                                    name="descripcion"
                                    value={descuento.descripcion}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Edad desde (días)"
                                    type="number"
                                    name="edadDesde"
                                    fullWidth
                                    value={descuento.edadDesde}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Edad hasta (días)"
                                    type="number"
                                    name="edadHasta"
                                    fullWidth
                                    value={descuento.edadHasta}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <InputLabel id="sexo-label">Sexo</InputLabel>
                                    <Select
                                        labelId="sexo-label"
                                        id="sexo-select"
                                        name="sexo"
                                        label="Sexo"
                                        value={descuento.sexo}
                                        onChange={e => setDescuento(prev => ({ ...prev, sexo: e.target.value }))}
                                        required
                                    >
                                        {sexos.map(s => (
                                            <MenuItem key={s.idSexo} value={s.idSexo}>
                                                {s.descripcionSexo}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <input
                                        type="file"
                                        id="urlImagen"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => {
                                            if (e.target.files && e.target.files[0]) {
                                                handleImageUpload(e.target.files[0]);
                                            }
                                        }}
                                    />

                                    {(imagePreview || descuento.urlImagen) && (
                                        <div className="mt-2">
                                            <img
                                                src={imagePreview || descuento.urlImagen}
                                                alt="Preview"
                                                style={{ maxWidth: '200px', maxHeight: '200px' }}
                                            />
                                        </div>
                                    )}
                                </FormControl>
                            </Grid>
                             <Grid item xs={12} md={6}>
                                <TextField label="Descripción Página Web" value={descripcionImgPagWeb} onChange={(e) => setDescripcionImgPagWeb(e.target.value)} fullWidth required />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Palabras clave" value={palabrasImgClavePagWeb} onChange={(e) => setPalabrasImgClavePagWeb(e.target.value)} fullWidth required />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    key={descuento.perfil?.idPerfil || 'null'} 
                                    options={perfiles}
                                    getOptionLabel={(option) => option.descripcionPerfil || ''}
                                    isOptionEqualToValue={(option, value) => option.idPerfil === value?.idPerfil}
                                    onChange={(event, newValue) => setDescuento(prev => ({ ...prev, perfil: newValue }))}
                                    renderInput={(params) => <TextField {...params} label="Perfil de Análisis" />}
                                    value={descuento.perfil}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Button variant="contained" color="primary" onClick={handleAgregarAnalisisPerfil}>
                                    Agregar Perfil
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    options={analisisDisponibles}
                                    getOptionLabel={(option) => option.descripcionTipoAnalisis}
                                    onChange={(event, newValue) => setDescuento(prev => ({ ...prev, analisis: newValue }))}
                                    renderInput={(params) => <TextField {...params} label="Análisis" />}
                                    value={descuento.analisis}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="Porcentaje"
                                    type="number"
                                    name="porcentaje"
                                    fullWidth
                                    value={descuento.porcentaje}
                                    onChange={handleNumberChange}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: 100,
                                        step: 1
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="% Remitido"
                                    type="number"
                                    name="porcentaje_remitido"
                                    fullWidth
                                    value={descuento.porcentaje_remitido}
                                    onChange={handleNumberChange}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: 100,
                                        step: 1
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" onClick={handleAgregar}>
                                    Agregar
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Análisis</TableCell>
                                            <TableCell>Porcentaje</TableCell>
                                            <TableCell>Remitido</TableCell>
                                            <TableCell>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listaDescuentos.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.analisis.descripcionTipoAnalisis}</TableCell>
                                                <TableCell>{item.porcentaje}%</TableCell>
                                                <TableCell>{item.porcentaje_remitido}%</TableCell>
                                                <TableCell>
                                                    <Button color="secondary" onClick={() => handleEliminar(index)} disabled={!tienePermiso('Eliminar Promoción Análisis')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 20 }}>
                                <Button variant="contained" color="secondary" onClick={onCancel}>
                                    Cancelar
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleGuardarPromocion} style={{ marginLeft: 10 }} disabled={!tienePermiso(isEditMode ? 'Editar Promoción Análisis' : 'Crear Promoción Análisis')}>
                                    Guardar Promoción
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                    {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default GestionPromocionesDAnalisis;
